import React from 'react';
import { Spin } from 'antd';

export default ({ isLoading = false, children = null, ...rest }) => (
  <Spin spinning={isLoading} {...rest}>
    {children}
  </Spin>
);
